import { createContext, useState } from "react";

export const ConfiguracaoGlebaContext = createContext(null);

const ConfiguracaoGlebaProvider = ({ children }) => {
  const [configuracaoGleba, setConfiguracaoGleba] = useState({
    tipoSafra: "",
    safra: "",
    gleba: "",
    observacoes: "",
  });
  // Aba (bloco cultura/cultivar) atualmente selecionada na tela de programacao
  const [activeCulturaIndex, setActiveCulturaIndex] = useState(0);
  // True quando o usuario ALTEROU a programacao (pra avisar antes de sair sem salvar)
  const [programacaoAlterada, setProgramacaoAlterada] = useState(false);
  const handleConfiguracaoGleba = (name, value) => {
    setConfiguracaoGleba((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSelectChange = (name) => {
    return (option) => {
      handleConfiguracaoGleba(name, option.value);
    };
  };
  return (
    <ConfiguracaoGlebaContext.Provider
      value={{
        configuracaoGleba,
        setConfiguracaoGleba,
        handleConfiguracaoGleba,
        handleSelectChange,
        activeCulturaIndex,
        setActiveCulturaIndex,
        programacaoAlterada,
        setProgramacaoAlterada,
      }}
    >
      {children}
    </ConfiguracaoGlebaContext.Provider>
  );
};

export default ConfiguracaoGlebaProvider;
